/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteCategoryCtrl',["$scope","$rootScope","$routeParams","CategoryData", function($scope,$rootScope,$routeParams,CategoryData)
    {
        $scope.dd = {
            currentCategoryId :  parseInt($routeParams.categoryId)
        }

        $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
        {
            if (newValue)// && !$scope.ad.view.currentCategoryView)
            {
                var category = CategoryData.getById( $scope.dd.currentCategoryId);
                if (category && category.isVisibleOnWebSite)
                {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentCategoryView($scope.ad.view.categoryRootView.getCategoryView(category),false);
                }
                else
                {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus ou n'est plus réservable.";
                }
            }
        });


    }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCategoryCtrl.js